/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import {
	IconChevronDownOutline18 as ChevronDown,
	IconChevronUpOutline18 as ChevronUp,
} from "nucleo-ui-outline-18"

import { IconButton, Shortcut, Tooltip } from "@productlane/ui"

import { useThreadContext } from "../../thread-context"

export function UpDownControls() {
	const { thread, goNext, goPrev, nextThread, prevThread } = useThreadContext()

	if (!thread) {
		return null
	}

	return (
		<div
			className="relative z-50 hidden flex-none items-center gap-2 sm:flex"
			onClick={(e) => {
				e.stopPropagation()
			}}
			onKeyDown={(e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.stopPropagation()
				}
			}}
			role="group"
			tabIndex={-1}
		>
			<Tooltip
				label={
					<span className="inline-flex gap-2">
						Navigate down <Shortcut>J</Shortcut>
					</span>
				}
			>
				<IconButton
					Icon={ChevronDown}
					variant="ghost"
					onClick={(e) => {
						e.preventDefault()
						e.stopPropagation()
						goNext()
					}}
					disabled={!nextThread}
				/>
			</Tooltip>
			<Tooltip
				label={
					<span className="inline-flex gap-2">
						Navigate up <Shortcut>K</Shortcut>
					</span>
				}
			>
				<IconButton
					Icon={ChevronUp}
					variant="ghost"
					onClick={(e) => {
						e.preventDefault()
						e.stopPropagation()
						goPrev()
					}}
					disabled={!prevThread}
				/>
			</Tooltip>
		</div>
	)
}
